module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1039-9579b04031f3e28f7e720d7cfb335c23.png";